/**
 * Progress Steps Component
 */

import React from 'react';
import Icon from '../../../components/AppIcon';
import { FORM_STEPS } from '../constants';

export const ProgressSteps = React.memo(({ currentStep }) => {
  return (
    <div className="flex items-center space-x-2 sm:space-x-4 overflow-x-auto pb-2">
      {FORM_STEPS.map((step, index) => (
        <div key={step.id} className="flex items-center space-x-2 sm:space-x-4">
          <div
            className={`flex items-center space-x-1 sm:space-x-2 px-2 sm:px-4 py-1.5 sm:py-2 rounded-lg whitespace-nowrap transition-colors text-xs sm:text-sm ${
              currentStep === step.id
                ? 'bg-primary text-white'
                : currentStep > step.id
                ? 'bg-green-100 text-green-700'
                : 'bg-secondary-100 text-text-muted'
            }`}
          >
            <Icon name={step.icon} size={14} className="sm:w-4 sm:h-4" />
            <span className="hidden sm:inline font-medium">{step.title}</span>
          </div>
          {index < FORM_STEPS.length - 1 && (
            <Icon name="ChevronRight" size={14} className="text-text-muted flex-shrink-0 sm:w-4 sm:h-4" />
          )}
        </div>
      ))}
    </div>
  );
});

ProgressSteps.displayName = 'ProgressSteps';
